import React, { useRef, useState } from 'react';

import videoSrc from '../../assets/img/Syrol 02 .mp4';
import icon1 from '../../assets/img/choose/home12/icon/1.png';
import icon2 from '../../assets/img/choose/home12/icon/2.png';
import icon3 from '../../assets/img/choose/home12/icon/3.png';

import bgImg from '../../assets/img/bg/home12/why-learn-bg.jpg';

const bgStyle = {
    backgroundImage: `url(${bgImg})`
}

const WhyChooseUs = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        if (videoRef.current) {
            videoRef.current.play();
            videoRef.current.muted = false;
            setIsPlaying(true);
        }
    };

    return (
        <div className="why-choose-us style3" style={bgStyle}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 md-mb-40">
                        <div className="img-part" style={{ position: 'relative' }}>
                            <video
                                ref={videoRef}
                                src={videoSrc}
                                controls
                                loop
                                style={{ width: '100%', maxHeight: '700px', borderRadius: '8px', objectFit: 'cover' }}
                                alt="Syrol Video"
                            />
                            {!isPlaying && (
                                <div
                                    onClick={handlePlay}
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        cursor: 'pointer',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        borderRadius: '50%',
                                        width: '60px',
                                        height: '60px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontSize: '24px'
                                    }}
                                >
                                    <i className="fa fa-play"></i>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-lg-6 pl-60 md-pl-14">
                        <div className="sec-title3 mb-30">
                            <h2 className=" title new-title margin-0 pb-14">Accelerate Your Digital Transformation</h2>
                            <div className="new-desc">We empower businesses to evolve, innovate, and lead in the digital era through strategic technology adoption and seamless integration.</div>
                        </div>
                        <div className="services-part mb-20">
                            <div className="services-icon">
                                <img src={icon1} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title">Strategic Digitization</h2>
                                <p className="services-txt">Tailored roadmaps to modernize legacy systems and digitize core business processes.</p>
                            </div>
                        </div>
                        <div className="services-part mb-20">
                            <div className="services-icon">
                                <img src={icon2} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title">Data-Driven Insights</h2>
                                <p className="services-txt">Leveraging analytics and AI to unlock actionable intelligence and drive smarter decisions.</p>
                            </div>
                        </div>
                        <div className="services-part mb-20">
                            <div className="services-icon">
                                <img src={icon1} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title">Cloud & Infrastructure</h2>
                                <p className="services-txt">Scalable cloud solutions that enhance agility, security, and operational efficiency.</p>
                            </div>
                        </div>
                        <div className="services-part">
                            <div className="services-icon">
                                <img src={icon3} alt="" />
                            </div>
                            <div className="services-text">
                                <h2 className="title">Customer-Centric Innovation</h2>
                                <p className="services-txt">Reimagining customer experiences with cutting-edge digital platforms and touchpoints.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WhyChooseUs;